import { useState, useMemo, useEffect } from "react";
import { LocationContext } from "context/locationContext";
import { LocationApiContext } from "context/locationApiContext";

import { COOKIES } from "constants/enum";
import { getCookiesValueByName } from "utils/cookie";

import { ActiveCity, LocationProviderProps } from "./LocationProvider.types";

export const LocationProvider = ({
    version,
    children,
}: LocationProviderProps) => {
    const [city, setCity] = useState<ActiveCity | null>(null);
    const [timezone, setTZ] = useState<string>(
        new Intl.DateTimeFormat().resolvedOptions().timeZone
    );

    useEffect(() => {
        const cityIDFromCookies = getCookiesValueByName(COOKIES.GEO_CITY_ID);
        const cityNameFromCookies = getCookiesValueByName(COOKIES.GEO_CITY);
        const timezoneFromCookies = getCookiesValueByName(COOKIES.GEO_TIMEZONE);
        if (cityIDFromCookies && cityNameFromCookies)
            setCity({
                id: parseInt(cityIDFromCookies, 10),
                name: decodeURIComponent(cityNameFromCookies),
            });
        if (timezoneFromCookies) {
            setTZ(decodeURIComponent(timezoneFromCookies));
        }
    }, []);

    const memoizedDataValue = useMemo(() => {
        return { version, city, timezone };
    }, [version, city, timezone]);
    const memoizedApiValue = useMemo(
        () => ({ onChangeCity: setCity, onChangeTimezone: setTZ }),
        []
    );

    return (
        <LocationContext.Provider value={memoizedDataValue}>
            <LocationApiContext.Provider value={memoizedApiValue}>
                {children}
            </LocationApiContext.Provider>
        </LocationContext.Provider>
    );
};
